import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getFtpList = createAsyncThunk("ftpList/getFtpList", async (payload) => {
  try {
    const response = await magnifiAPI.getFtpList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const ftpPublish = createAsyncThunk("ftpList/ftpPublish", async (payload) => {
  try {
    const response = await magnifiAPI.ftpPublish(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
